import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import { fromJS } from 'immutable';
import MastheadBarButtonRecord from '../../../../../records/MastheadBarButtonRecord';
import NavigationItemRecord from '../../../../../records/NavigationItemRecord';
import getClassicLink from './get-classic-link';
import getMenuSection from './get-menu-section';
export default function mapMenuItemSections(sections) {
  return sections.reduce(function (subMenus, subMenuItem) {
    if (Array.isArray(subMenuItem.links)) {
      var subMenuLinks = subMenuItem.links.map(function (subMenuLink) {
        // 3rd Level LINKS
        return new NavigationItemRecord(getClassicLink(subMenuLink));
      });
      var profileSectionBtn = getMenuSection(subMenuItem, fromJS(subMenuLinks));
      subMenus.push(new MastheadBarButtonRecord(profileSectionBtn));
    }

    return subMenus;
  }, []);
}